/**
 * @ngdoc directives
 * @memberof mercury.directives
 * @name headerbadge
 * @description Applies a badge under the table header text and adjusts
 *   the positioning of the header content to line up with the content
 *   of the table in the column.
 */
angular.module('mercury.directives.headerbadge', [])
.directive('headerbadge', ["$rootScope", "logger", function($rootScope, logger) {

  // This badge width should match the width defined in the .badge-header CSS
  // rule
  var BADGE_WIDTH = 35;
  // This weighting value is used to multiply the number of text characters by
  // to get an approximate width of the content - it can be tweaked if the font
  // size we use changes.
  var CHAR_WEIGHTING = 1.6;

  // Padding value for the panel containing the table, used to prevent the offset
  // for centering headers pushing too close to the edges.
  var PANEL_PADDING = 10;

  // Helper function to find which header index the given
  // element is, as well as how many header columns there are.
  function getHeaderElementDetail(element) {
    var allHeaderElements = element.closest('table').querySelectorAll('thead th');

    var i;
    for (i = 0; i < allHeaderElements.length; i++) {
      if (allHeaderElements[i].querySelector('.header-badge') == element) {
        break;
      }
    }

    return {
      numColumns: allHeaderElements.length,
      columnNum: i + 1
    };
  }

  return {
    restrict: 'A',
    transclude: true,
    templateUrl: 'directives/headerbadge/headerbadge.tpl.html',
    scope: {
      'type': '@headerbadge',
      'tooltipText': '@headerbadgeTooltip'
    },
    link: function(scope, angularElement) {
      // The code in here deals with aligning the header rows centered over the
      // top of the content within the columns of the table. This is a bit tricky
      // because we have right aligned table content and want to offset the table
      // headers a bit further right than they naturally sit. We do this by applying
      // a negative margin to the header element.

      // We listen for the placeholder being removed before we align columns
      // this is because we need the content in the table to work out where
      // to offset the columns to.
      //
      // Note in future we may want to enhance this to support tables that
      // don't have loaders on them, but for now in those cases the alignment
      // will just be a bit off from what we'd prefer.
      $rootScope.$on('loading-placeholder-removed', function() {

        // This timeout is a workaround to cede processing to Angular so the table
        // content is actually rendered before we proceed - without this we end up
        // running before the content is placed into the table and still don't get
        // the detail we need about table content.
        setTimeout(function() {
          try {
            var element = angularElement.get(0).querySelector('.header-badge');

            var headerElementDetail = getHeaderElementDetail(element);
            var headerContentWidth = element.getBoundingClientRect().width;
            var rowContentWidth = element.closest('table')
              .querySelector('tbody tr:first-of-type td:nth-child(' + headerElementDetail.columnNum + ')')
              .innerText.length * CHAR_WEIGHTING;

            var offset = (((headerContentWidth - (BADGE_WIDTH / 2)) / 2) - rowContentWidth) * -1;

            // We need to prevent the offset pushing beyond the padding of the container
            // the table sits within when we're dealing with the first and last columns.
            if (
              headerElementDetail.columnNum === 1 &&
              offset > PANEL_PADDING
            ) {
              // restrict from pushing too far left
              offset = PANEL_PADDING;
            } else if (
              headerElementDetail.columnNum === headerElementDetail.numColumns &&
              offset < -PANEL_PADDING
            ) {
              // restrict from pushing too far right
              offset = -PANEL_PADDING;
            }
            element.style.marginRight = offset + 'px';
          } catch (e) {
            logger.error('unable to calculate headerbadge offset for element %o due to %o', angularElement, e);
          }

        }, 0);

      });
    }
  };
}]);
